import React from 'react'

export const ConfigPanel = () => {
  return <div data-testid='ConfigPanel-component'>ConfigPanel component</div>
}

export default ConfigPanel
